export default __webpack_public_path__ + "static/media/20210306.82adad1c.webp";